// import { StrictMode } from 'react';
import { ConfigProvider } from 'antd';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { store } from '@/redux/store';

import { Sentry } from '@/sentry';

import App from '@/App.tsx';

import '@/index.css';

createRoot(document.getElementById('root')!).render(
  // <StrictMode>
  <Provider store={store}>
    <div className="font-poppins">
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: 'var(--primary)',
            fontFamily: 'poppins',
          },
          components: {
            Select: {
              optionSelectedColor: '#ffffff',
            },
            Button: {
              defaultBg: 'var(--btn-bg)',
              defaultColor: 'var(--btn-text)',
              defaultHoverBg: 'var(--btn-hover-bg)',
              defaultHoverColor: 'var(--btn-hover-text)',
              defaultActiveBg: 'var(--btn-active-bg)',
              defaultActiveColor: 'var(--btn-active-text)',
              colorBgContainerDisabled: 'var(--btn-disabled-bg)',
              colorTextDisabled: 'var(--btn-disabled-text)',
              defaultBorderColor: 'transparent',
            },
            Input: {
              colorText: 'var(--cardClr-text)',
              colorTextPlaceholder: 'var(--cardClr-textSecondary)',
              activeBorderColor: 'var(--primary)',
              hoverBorderColor: 'var(--primary-light)',
            },
            Modal: {
              colorBgElevated: 'var(--cardClr)',
              colorText: 'var(--cardClr-textSecondary)',
              colorTextHeading: 'var(--cardClr-text)',
              colorIcon: 'var(--cardClr-textSecondary)',
              titleColor: 'var(--cardClr-text)',
            },
          },
        }}
      >
        <Sentry.ErrorBoundary
          fallback={
            <div className="min-h-screen bg-gray-50 px-6 py-10 text-gray-900" role="alert">
              <div className="mx-auto max-w-lg rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
                <h1 className="text-lg font-semibold">Something went wrong.</h1>
                <p className="mt-2 text-sm text-gray-600">The issue has been reported. Please refresh the page and try again.</p>
              </div>
            </div>
          }
        >
          <App />
        </Sentry.ErrorBoundary>
      </ConfigProvider>
    </div>
  </Provider>,
  // </StrictMode>,
);
